import { injectStoreInMissingAuthCredentialInterceptor } from '@/features/api/terminal/missingAuthCredentialInterceptor'
import reducer from '@/redux/reducers'
import { configureStore } from '@reduxjs/toolkit'

const store = configureStore({
    reducer,
})

export type Store = typeof store
export type RootState = ReturnType<Store['getState']>
export type AppDispatch = Store['dispatch']

injectStoreInMissingAuthCredentialInterceptor(store)

export default store
